import React from 'react';
import flatten from 'lodash/flatten';
import { getColumnFilteredValue } from '../../components/table/columnFormatHelpers';
import { SiteEnrollments } from '../../components/site/SiteEnrollments';
import { buildProgramFilter } from './buildProgramFilter';
import { IProgram } from './interface';

interface IProgramFilterOptions {
    title?: string;
    includeWithoutProgram?: boolean;
}

export const getProgramFilterValue = (state: any) => {
    let { filteredValue } = getColumnFilteredValue('program_id', state?.filter || {});
    if (Array.isArray(filteredValue)) {
        filteredValue = flatten(filteredValue).map(programId => programId.toString());
    }
    return filteredValue;
};

export function buildProgramTableFilter(
    state: any,
    programs: IProgram[],
    { title = 'Program', includeWithoutProgram = false }: IProgramFilterOptions,
    isSidebarEnabled: boolean = false
) {
    return {
        title: title,
        dataIndex: 'program_id',
        ellipsis: { showTitle: false },
        render: (text: string, record: any) => <SiteEnrollments value={record} />,

        ...(isSidebarEnabled
            ? { filtered: false }
            : {
                  filterMultiple: true,
                  filters: buildProgramFilter(programs, includeWithoutProgram),
                  filteredValue: getProgramFilterValue(state),
                  filterSearch: (input: string, record: any) => record?.fullText?.toLowerCase().includes(input.toLowerCase()),
              }),
    };
}
